'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import ModalMotorista from './ModalMotorista';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaMotorista({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newMotorista, setNewMotorista] = useState('');

  // Estados para o ModalRetorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleAddMotorista = () => {
    if (newMotorista.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, nome: newMotorista, ativo: true },
      ]);
      setNewMotorista('');
      setIsModalOpen(false);
      setMensagemRetorno('Motorista adicionado com sucesso!');
      setTipoRetorno('sucesso');
      setModalRetornoOpen(true);
    }
  };

  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno('Motoristas excluídos com sucesso!');
    setTipoRetorno('sucesso');
    setModalRetornoOpen(true);
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalMotorista
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        handleAddMotorista={handleAddMotorista}
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
